import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Icon13 from "../../img/7481d4f175f497fa3ca635d9ea8974d559a00bf54762cdfe73ec49ac971c04f3.svg";
import { AlertPopup } from '../common/AlertPopup';

export function UpdateContactModal({ isOpen, onClose, sectionType, opportunityName }) {
  const [accountSearch, setAccountSearch] = useState('');
  const [isEmailDropdownVisible, setIsEmailDropdownVisible] = useState(false);
  const [isAccountDropdownVisible, setIsAccountDropdownVisible] = useState(false);
  const [emailContacts, setEmailContacts] = useState([]);
  const [accountContacts, setAccountContacts] = useState([]);
  const [noEmailFound, setNoEmailFound] = useState(false);
  const [selectedContact, setSelectedContact] = useState({
    Email: '',
    Email_Alternate__c: '',
    Personal_Email__c: '',
    FirstName: '',
    LastName: '',
    Title: '',
    Department: '',
    Type: '',
    GMB_Type__c: '',
    GMB_Region__c: '',
    Phone: '',
    MobilePhone: '',
    Fax: '',
    MailingAddress: {
      street: '',
      city: '',
      state: '',
      postalCode: '',
      country: 'United States of America',
    },
    OtherAddress: {
      street: '',
      city: '',
      state: '',
      postalCode: '',
      country: 'United States of America',
    },
    GMB_Account_Billing_State_Short_Code__c: '',
    AccountName: '',
    AccountId: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: '', isError: false });
  const [emailValidation, setEmailValidation] = useState({
    isValid: false,
    isChecking: false,
    exists: false
  });
  const [selectedGroup, setSelectedGroup] = useState('');
  const [modalPosition, setModalPosition] = useState(0);

  const states = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  const contactTypeOptions = {
    "Nettles Project Team": [
      "Operations Manager",
      "Project Manager", 
      "Project Accountant",
      "Submittals",
      "Salesperson"
    ],
    "GC/Customer": [
      "Project Manager",
      "Asst. Project Manager",
      "Superintendent",
      "Project Engineer",
      "Billing Contact"
    ],
    "Designer/Consultant": [
      "Architect",
      "Engineer",
      "Inspector",
      "Consultant"
    ],
    "Vendors": ["Vendor"]
  };

  const typeOptions = [
    "Architect",
    "Code Official",
    "Consultant-Acoustical",
    "Consultant-Roof",
    "Distributor",
    "Engineer-Civil/GeoTech",
    "Engineer-Structural",
    "GC/CM",
    "GC/CM-Heavy Civil",
    "Inspector",
    "Interior Designer",
    "Manufacturer",
    "Owner/Developer",
    "Roofer",
    "Sales Representative",
    "Shipping Company",
    "Steel Supply/Fab/Erection",
    "Sub-Contractor/Installer",
    "Trade Associations",
    "Vendor-Internal",
  ];

  const handleAccountSearch = async (e) => {
    const accountName = e.target.value;
    setSelectedContact((prev) => ({ ...prev, AccountName: accountName, AccountId: '', }));

    if (accountName.trim().length < 3) {
      setIsAccountDropdownVisible(false);
      setAccountContacts([]);
      return;
    }

    try {
      const response = await axios.get(
        `https://projects-dev.nettlescs.com:5000/api/salesforce/accounts/name/${accountName}`
      );
      const records = response.data.records;

      if (records.message === "No record found for the given account name") {
        setAccountContacts([]); // Ensure it's set to an empty array
        setIsAccountDropdownVisible(false);
      } else if (Array.isArray(records.records)) {
        setAccountContacts(records.records); // Ensure it's an array
        setIsAccountDropdownVisible(true);
      }
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  const handleAccountSelect = (account) => {
    setSelectedContact((prev) => ({
      ...prev,
      AccountName: account.Name,
      AccountId: account.Id, // This should be the Salesforce Account ID
    }));
    setIsAccountDropdownVisible(false);
  };

  const handleEmailSearch = async (e) => {
    const email = e.target.value.trim();
    setAccountSearch(email);
  
    // Reset email validation if the main email field matches the new search email
    if (email === selectedContact.Email) {
      setEmailValidation({ isValid: false, isChecking: false, exists: false });
    }

    // Reset fields except email and id
    setSelectedContact((prev) => ({
      ...prev,
      Email: email,
      Id: prev.Id || "",
      Email_Alternate__c: "",
      Personal_Email__c: "",
      FirstName: "",
      LastName: "",
      Title: "",
      Department: "",
      Type: "",
      GMB_Type__c: "",
      GMB_Region__c: "",
      Phone: "",
      MobilePhone: "",
      Fax: "",
      MailingAddress: {
        street: "",
        city: "",
        state: "",
        postalCode: "",
        country: "United States of America",
      },
      OtherAddress: {
        street: "",
        city: "",
        state: "",
        postalCode: "",
        country: "United States of America",
      },
      GMB_Account_Billing_State_Short_Code__c: "",
      AccountName: "",
      AccountId: prev.AccountId || "",
    }));
  
    if (!email) {
      setNoEmailFound(false);
      setEmailContacts([]);
      setIsEmailDropdownVisible(false);
      return;
    }
  
    try {
      const response = await axios.get(
        `https://projects-dev.nettlescs.com:5000/api/salesforce/contacts/email/${email}`
      );
      const data = response.data;
  
      if (data.records?.message === "No record found for the given email") {
        // No records found - show create new contact form
        setNoEmailFound(true);
        setEmailContacts([]);
        setIsEmailDropdownVisible(false);
      } else if (data.records?.records && Array.isArray(data.records.records)) {
        // Multiple records found - show dropdown
        setNoEmailFound(false);
        const contacts = data.records.records;
        setEmailContacts(contacts);
        setIsEmailDropdownVisible(true);
      } else if (data.records && !Array.isArray(data.records)) {
        // Single record found - populate form
        const record = data.records;
        handleContactSelect(record);
        setNoEmailFound(false);
        setEmailContacts([]);
        setIsEmailDropdownVisible(false);
      }
    } catch (error) {
      console.error("Error fetching contact:", error);
      setNoEmailFound(true);
      setEmailContacts([]);
      setIsEmailDropdownVisible(false);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleCreateContact = async () => {
    const {
      FirstName,
      LastName,
      AccountId,
      Title,
      Department,
      Phone,
      MobilePhone,
      Fax,
      Email,
      Email_Alternate__c,
      Personal_Email__c,
      Type,
      GMB_Region__c,
      MailingAddress,
      OtherAddress,
      GMB_Account_Billing_State_Short_Code__c,
    } = selectedContact;
  
    // Validate required fields
    if (!AccountId || !FirstName || !LastName || !Email || !Type || !GMB_Region__c) {
      setAlert({
        show: true,
        message: "Please fill all required fields: Account, First Name, Last Name, Email, Type, and Region",
        isError: true
      });
      return;
    }
  
    // Prepare payload for Salesforce API
    const salesforcePayload = {
      Salutation: "Mr",
      FirstName,
      LastName,
      AccountId,
      Title: Title || "",
      Department: Department || "",
      Phone: Phone || "",
      MobilePhone: MobilePhone || "",
      Fax: Fax || "",
      Email,
      Email_Alternate__c: Email_Alternate__c || "",
      Personal_Email__c: Personal_Email__c || "",
      GMB_Type__c: Type,
      GMB_Region__c,
      MailingStreet: MailingAddress?.street || "",
      MailingCity: MailingAddress?.city || "",
      MailingState: MailingAddress?.state || "",
      MailingPostalCode: MailingAddress?.postalCode || "",
      MailingCountry: MailingAddress?.country || "United States of America",
      OtherStreet: OtherAddress?.street || "",
      OtherCity: OtherAddress?.city || "",
      OtherState: OtherAddress?.state || "",
      OtherPostalCode: OtherAddress?.postalCode || "",
      OtherCountry: OtherAddress?.country || "United States of America",
      GMB_Account_Billing_State_Short_Code__c: selectedContact.Account_Billing_State?.toUpperCase() || "TX"
    };
  
    setIsLoading(true);
    try {
      // First create contact in Salesforce
      const salesforceResponse = await axios.post(
        "https://projects-dev.nettlescs.com:5000/api/salesforce/contacts",
        salesforcePayload,
        { headers: { "Content-Type": "application/json" } }
      );
  
      // If Salesforce contact creation is successful, create in Projects API
      if (salesforceResponse.data) {
        // Then call handleSubmit to make the Projects API call
        await handleSubmit(new Event('submit'));
        setIsSuccess(true);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        console.error("Error creating contact:", error.response.data);
        setAlert({
          show: true,
          message: `Failed to create contact! ${error.response.data.message || "Unknown error"}`,
          isError: true
        });
      } else {
        console.error("Error creating contact:", error);
        setAlert({
          show: true,
          message: "Failed to create contact due to a network error or invalid response.",
          isError: true
        });
      }
    }
  };

  const handleContactSelect = (contact) => {
    const [firstName, ...lastNameParts] = contact.Name.split(' ');
    const lastName = lastNameParts.join(' ');
  
    setSelectedContact({
      ...selectedContact,
      Id: contact.Id,
      Email: contact.Email || '',
      Email_Alternate__c: contact.Email_Alternate__c || '',
      Personal_Email__c: contact.Personal_Email__c || '',
      FirstName: firstName || '',
      LastName: lastName || '',
      Title: contact.Title || '',
      Department: contact.Department || '',
      Type: contact.GMB_Type__c || '',
      GMB_Type__c: contact.GMB_Type__c || '',
      GMB_Region__c: contact.GMB_Region__c || '',
      Phone: contact.Phone || '',
      MobilePhone: contact.MobilePhone || '',
      Fax: contact.Fax || '',
      MailingAddress: contact.MailingAddress || {
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: 'United States of America',
      },
      OtherAddress: contact.OtherAddress || {
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: 'United States of America',
      },
      GMB_Account_Billing_State_Short_Code__c: contact.GMB_Account_Billing_State_Short_Code__c || '',
      AccountName: contact.Account?.Name || '',
      AccountId: contact.AccountId || '',
    });
    setNoEmailFound(false);
    setIsEmailDropdownVisible(false);
  };

  const handleUpdateContact = async () => {
    const {
      Id,
      Email,
      FirstName,
      LastName,
      AccountName,
      AccountId,
      Type,
      GMB_Region__c,
    } = selectedContact;
  
    // Check required fields only if they are not already populated
    if (!Id) {
      setAlert({
        show: true,
        message: "Contact ID is missing. Ensure the contact has been selected properly.",
        isError: true
      });
      return;
    }
  
    // Check if Type is empty and show a dropdown or prompt to select Type
    if (!Type) {
      setAlert({
        show: true,
        message: "Please select a Type for the contact before updating.",
        isError: true
      });
      return;
    }
  
    // Check other required fields
    if (!Email?.trim() || !FirstName?.trim() || !LastName?.trim() || !GMB_Region__c?.trim()) {
      setAlert({
        show: true,
        message: "Please fill all required fields: Email, First Name, Last Name, and Region.",
        isError: true
      });
      return;
    }
  
    let accountId = AccountId;
  
    // If AccountName is populated but AccountId is missing, fetch it from the API
    if (!AccountId?.trim() && AccountName?.trim()) {
      try {
        const response = await axios.get(
          `https://projects-dev.nettlescs.com:5000/api/salesforce/accounts/name/${AccountName}`
        );
  
        const accountData = response.data.records;
        if (accountData && accountData.Id) {
          accountId = accountData.Id;
          setSelectedContact((prev) => ({
            ...prev,
            AccountId: accountData.Id,
          }));
        } else {
          setAlert({
            show: true,
            message: "Failed to fetch Account ID. Ensure the Account Name is valid.",
            isError: true
          });
          return;
        }
      } catch (error) {
        console.error("Error fetching Account ID:", error);
        setAlert({
          show: true,
          message: "Failed to fetch Account ID. Please verify the Account Name.",
          isError: true
        });
        return;
      }
    }
  
    // Ensure accountId is present
    if (!accountId?.trim()) {
      setAlert({
        show: true,
        message: "Please select a valid Account.",
        isError: true
      });
      return;
    }
  
    if (emailValidation.exists) {
      setAlert({
        show: true,
        message: "Please use a unique email address. This email already exists in the database.",
        isError: true
      });
      return;
    }
  
    // Prepare payload for Salesforce API
    const payload = {
      Salutation: "Mr",
      Email,
      FirstName,
      LastName,
      AccountId: accountId,
      GMB_Type__c: selectedContact.Type,
      GMB_Region__c,
      Title: selectedContact.Title || "",
      Department: selectedContact.Department || "",
      Phone: selectedContact.Phone || "",
      MobilePhone: selectedContact.MobilePhone || "",
      Fax: selectedContact.Fax || "",
      Email_Alternate__c: selectedContact.Email_Alternate__c || "",
      Personal_Email__c: selectedContact.Personal_Email__c || "",
      MailingStreet: selectedContact.MailingAddress?.street || "",
      MailingCity: selectedContact.MailingAddress?.city || "",
      MailingState: selectedContact.MailingAddress?.state || "",
      MailingPostalCode: selectedContact.MailingAddress?.postalCode || "",
      MailingCountry: selectedContact.MailingAddress?.country || "United States of America",
      OtherStreet: selectedContact.OtherAddress?.street || "",
      OtherCity: selectedContact.OtherAddress?.city || "",
      OtherState: selectedContact.OtherAddress?.state || "",
      OtherPostalCode: selectedContact.OtherAddress?.postalCode || "",
      OtherCountry: selectedContact.OtherAddress?.country || "United States of America",
      GMB_Account_Billing_State_Short_Code__c: selectedContact.Account_Billing_State?.toUpperCase() || "TX"
    };
  
    setIsLoading(true);
    try {
      // First make the Salesforce API call
      const response = await axios.patch(
        `https://projects-dev.nettlescs.com:5000/api/salesforce/contacts/id/${Id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Host: "20.110.43.107",
          },
        }
      );

      // Then call handleSubmit to make the Projects API call
      await handleSubmit(new Event('submit'));

      setIsSuccess(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error updating contact:", error);
      if (error.response) {
        setAlert({
          show: true,
          message: `Failed to update contact! ${error.response.data.message || "Unknown error"}`,
          isError: true
        });
      } else {
        setAlert({
          show: true,
          message: "Failed to update contact due to a network error or invalid response.",
          isError: true
        });
      }
    }
  };

  const handleCloseAlert = () => {
    setAlert({ show: false, message: '', isError: false });
  };

  const validateEmailField = async (email) => {
    // If the email matches the search email, don't show any validation
    if (email === accountSearch) {
      setEmailValidation({ isValid: false, isChecking: false, exists: false });
      return;
    }

    if (!email || !validateEmail(email)) {
      setEmailValidation({ isValid: false, isChecking: false, exists: false });
      return;
    }

    setEmailValidation(prev => ({ ...prev, isChecking: true }));
    try {
      const response = await axios.get(
        `https://projects-dev.nettlescs.com:5000/api/salesforce/contacts/email/${email}`
      );
      
      const exists = response.data.records && 
        response.data.records.message !== "No record found for the given email";
      
      setEmailValidation({
        isValid: !exists,
        isChecking: false,
        exists: exists
      });
    } catch (error) {
      console.error("Error checking email:", error);
      setEmailValidation({ isValid: false, isChecking: false, exists: false });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const projectData = JSON.parse(localStorage.getItem('selectedProjectDetails'));
      const opportunityUUID = parseInt(projectData?.opportunityUUID, 10);

      // Validate that opportunityUUID is a valid integer
      if (!opportunityUUID || isNaN(opportunityUUID)) {
        throw new Error('Invalid Opportunity UUID');
      }

      // Validate AccountId is present
      if (!selectedContact.AccountId) {
        throw new Error('AccountId is required');
      }

      // Validate Type is one of the allowed values
      if (!typeOptions.includes(selectedContact.Type)) {
        throw new Error('Invalid Type value');
      }

      // Start with the same payload structure as Salesforce API
      const basePayload = {
        Salutation: "Mr",
        FirstName: selectedContact.FirstName,
        LastName: selectedContact.LastName,
        AccountId: selectedContact.AccountId,
        Title: selectedContact.Title || "",
        Department: selectedContact.Department || "",
        Phone: selectedContact.Phone || "",
        MobilePhone: selectedContact.MobilePhone || "",
        Fax: selectedContact.Fax || "",
        Email: selectedContact.Email,
        Email_Alternate__c: selectedContact.Email_Alternate__c || "",
        Personal_Email__c: selectedContact.Personal_Email__c || "",
        GMB_Type__c: selectedContact.Type,
        GMB_Region__c: selectedContact.GMB_Region__c,
        MailingStreet: selectedContact.MailingAddress?.street || "",
        MailingCity: selectedContact.MailingAddress?.city || "",
        MailingState: selectedContact.MailingAddress?.state || "",
        MailingPostalCode: selectedContact.MailingAddress?.postalCode || "",
        MailingCountry: selectedContact.MailingAddress?.country || "United States of America",
        OtherStreet: selectedContact.OtherAddress?.street || "",
        OtherCity: selectedContact.OtherAddress?.city || "",
        OtherState: selectedContact.OtherAddress?.state || "",
        OtherPostalCode: selectedContact.OtherAddress?.postalCode || "",
        OtherCountry: selectedContact.OtherAddress?.country || "United States of America",
        GMB_Account_Billing_State_Short_Code__c: selectedContact.Account_Billing_State?.toUpperCase() || "TX"
      };

      // Add the three additional fields for Projects API
      const projectsApiPayload = {
        ...basePayload,
        Opportunity_System_Wide_ID__c: opportunityUUID,
        Group: selectedGroup,
        ContactType: selectedContact.contactType
      };

      // Make API call to Projects API
      await axios.post('https://projects-dev.nettlescs.com:5000/api/contacts', projectsApiPayload);
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setAccountSearch('');
      setAccountContacts([]);
      setEmailContacts([]);
      setNoEmailFound(false);
      setIsSuccess(false);
      setEmailValidation({
        isValid: false,
        isChecking: false,
        exists: false
      });
      setSelectedContact(prev => ({
        ...prev,
        Email: '',
        Email_Alternate__c: '',
        Personal_Email__c: '',
        FirstName: '',
        LastName: '',
        Title: '',
        Department: '',
        GMB_Type__c: '',
        GMB_Region__c: '',
        Phone: '',
        MobilePhone: '',
        Fax: '',
        MailingAddress: {
          street: '',
          city: '',
          state: '',
          postalCode: '',
          country: 'United States of America',
        },
        OtherAddress: {
          street: '',
          city: '',
          state: '',
          postalCode: '',
          country: 'United States of America',
        },
        GMB_Account_Billing_State_Short_Code__c: '',
        AccountName: '',
        AccountId: '',
      }));
    } else if (sectionType) {
      setSelectedGroup(sectionType);
      if (sectionType === "Vendors") {
        setSelectedContact(prev => ({
          ...prev,
          contactType: "Vendor"
        }));
      }
    }
  }, [isOpen, sectionType]);

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY || window.pageYOffset;
      setModalPosition(scrollY + 100); // Add 100px offset to move it down
    }
  }, [isOpen]);

  // You can use sectionType to customize the modal based on the section
  const getModalTitle = () => {
    const baseTitle = (() => {
      switch(sectionType) {
        case "Nettles Project Team":
          return "Update Nettles Project Team Contact";
        case "GC/Customer":
          return "Update GC/Customer Contact";
        case "Vendors":
          return "Update Vendor Contact";
        case "Designer/Consultant":
          return "Update Designer/Consultant Contact";
        default:
          return "Update Contact";
      }
    })();

    return opportunityName ? (
      <span>
        {baseTitle} for <span className="text-red-600">{opportunityName}</span>
      </span>
    ) : baseTitle;
  };

  if (!isOpen) return null;

  const modalStyle = {
    marginTop: `${modalPosition}px`,
    minHeight: '100vh', // Add minimum height of 50% viewport height
    maxHeight: 'calc(100vh - 100px)', // Increase max height
    overflowY: 'auto'
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50">
      {alert.show && (
        <AlertPopup
          message={alert.message}
          onClose={handleCloseAlert}
          isError={alert.isError}
        />
      )}
      <div className="relative w-3/4 bg-white rounded-lg mt-[100px]">
        <button
          onClick={() => {
            setIsSuccess(false);
            onClose();
          }}
          className="absolute -top-10 -right-1 text-white text-3xl font-normal cursor-pointer z-50"
        >
          ×
        </button>

        <div className="sticky top-0 bg-white p-6 border-b border-gray-200 rounded-t-lg z-40 shadow-sm">
          <h2 className="text-xl font-semibold">{getModalTitle()}</h2>
        </div>

        <div className="max-h-[calc(100vh-80px)] overflow-y-auto [&::-webkit-scrollbar]:w-1.5 
        [&::-webkit-scrollbar-track]:bg-gray-100 
        [&::-webkit-scrollbar-thumb]:bg-red-700/40
        [&::-webkit-scrollbar-thumb]:rounded-full 
        [&::-webkit-scrollbar-track]:rounded-full
        hover:[&::-webkit-scrollbar-thumb]:bg-red-700/60">
          {isSuccess ? (
            <div className="min-h-[400px] flex flex-col items-center justify-center p-6">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {noEmailFound ? "Contact Created Successfully!" : "Contact Updated Successfully!"}
              </h2>
              <button
                onClick={() => {
                  setIsSuccess(false);
                  onClose();
                }}
                className="bg-red-700 text-white py-2 px-8 rounded-lg hover:bg-red-800"
              >
                Done
              </button>
            </div>
          ) : (
            <div className="p-6">
              <form 
                onSubmit={handleSubmit} 
                className="space-y-4"
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
              >
                {isLoading && (
                  <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-700"></div>
                  </div>
                )}

                <div style={{ display: 'none' }}>
                  <input type="text" autoComplete="chrome-off" />
                  <input type="text" autoComplete="off" />
                </div>

                <div className="mb-4">
                  <label className="block text-sm text-gray-600 mb-1">Email<span className="text-red-500">*</span></label>
                  <div className="relative border rounded-md">
                    <div className="flex items-center">
                      <input
                        type="text"
                        value={accountSearch}
                        onChange={handleEmailSearch}
                        placeholder="Search by email"
                        className="w-full p-2 border-0 focus:outline-none"
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <img src={Icon13} alt="Search Icon" className="w-5 h-5 mr-2 cursor-pointer" />
                    </div>

                    {isEmailDropdownVisible && emailContacts.length > 0 && (
                      <div className="absolute top-full left-0 bg-white border rounded-md mt-1 w-full shadow-lg z-10">
                        <ul>
                          {emailContacts.map((contact) => (
                            <li
                              key={contact.Id}
                              className="p-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() => handleContactSelect(contact)}
                            >
                              {contact.Name} - {contact.Email}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  {noEmailFound && (
                      <p className="text-red-600 text-sm mt-1">* Email not found - Fill in the form to create a new contact</p>
                    )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Group<span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      value={selectedGroup}
                      className="w-full p-2 border rounded-md bg-gray-100"
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Contact Type<span className="text-red-500">*</span></label>
                    <select
                      className="w-full p-2 border rounded-md"
                      value={selectedContact.contactType}
                      onChange={(e) =>
                        setSelectedContact(prev => ({ ...prev, contactType: e.target.value }))
                      }
                      required
                    >
                      <option value="">Select Contact Type</option>
                        {contactTypeOptions[selectedGroup]?.map((contactType) => (
                          <option key={contactType} value={contactType}>
                            {contactType}
                          </option>
                    ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Email<span className="text-red-500">*</span></label>
                  <div className="relative">
                    <input
                      type="email"
                      value={selectedContact.Email}
                      className={`w-full p-2 border rounded-md ${
                        emailValidation.exists ? 'border-red-500' : 
                        emailValidation.isValid ? 'border-green-500' : ''
                      }`}
                      onChange={(e) => {
                        setSelectedContact((prev) => ({ ...prev, Email: e.target.value }));
                        setEmailValidation({ isValid: false, isChecking: false, exists: false });
                      }}
                      onBlur={(e) => validateEmailField(e.target.value)}
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                    {emailValidation.isChecking ? (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-red-700"></div>
                      </div>
                    ) : emailValidation.isValid ? (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-green-500">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                    ) : null}
                  </div>
                  {emailValidation.exists && (
                    <p className="text-red-500 text-sm mt-1">This email already exists in the database</p>
                  )}
                </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Email - Alternate</label>
                    <input
                      type="email"
                      value={selectedContact.Email_Alternate__c}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, Email_Alternate__c: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Personal Email</label>
                    <input
                      type="email"
                      value={selectedContact.Personal_Email__c}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, Personal_Email__c: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div className="col-span-3">
                    <label className="block text-sm text-gray-600 mb-1">Account Name<span className="text-red-500">*</span></label>
                    <div className="relative border rounded-md">
                      <div className="flex items-center">
                        <input
                          type="text"
                          value={selectedContact.AccountName}
                          onChange={handleAccountSearch}
                          placeholder="Search by account name"
                          className="w-full p-2 border-0 focus:outline-none"
                          disabled={isLoading}
                          autoComplete="new-password"
                          autoCorrect="off"
                          spellCheck="false"
                          data-form-type="other"
                        />
                        <img src={Icon13} alt="Search Icon" className="w-5 h-5 mr-2 cursor-pointer" />
                      </div>
                      {isAccountDropdownVisible && (
                        <div
                          className="absolute top-full left-0 bg-white border rounded-md mt-1 w-full shadow-lg z-10"
                          style={{
                            maxHeight: '200px', // Set the maximum height
                            overflowY: 'auto', // Enable vertical scrolling
                          }}
                        >
                          <ul>
                          {(accountContacts || []).map((account) => (
                            <li
                              key={account.Id}
                              className="p-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() => handleAccountSelect(account)}
                            >
                              {account.Name}
                            </li>
                          ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">First Name<span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      value={selectedContact.FirstName}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, FirstName: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Last Name<span className="text-red-500">*</span></label>
                    <input
                      type="text"
                      value={selectedContact.LastName}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, LastName: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Title</label>
                    <input
                      type="text"
                      value={selectedContact.Title}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, Title: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Department</label>
                    <input
                      type="text"
                      value={selectedContact.Department}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, Department: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">
                      Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="w-full p-2 border rounded-md"
                      value={selectedContact.Type || ""}
                      onChange={(e) =>
                        setSelectedContact(prev => ({ ...prev, Type: e.target.value }))
                      }
                      style={{ color: !selectedContact.Type ? "gray" : "black" }}
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    >
                      <option value="" disabled>Choose</option>
                      {typeOptions.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">
                      Region <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="w-full p-2 border rounded-md"
                      value={selectedContact.GMB_Region__c}
                      onChange={(e) =>
                        setSelectedContact({ ...selectedContact, GMB_Region__c: e.target.value })
                      }
                      style={{ color: selectedContact.GMB_Region__c === "" ? "gray" : "black" }}
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    >
                      <option value="" disabled>Choose</option>
                      {[
                        "AR-Entire State",
                        "IA-Entire State",
                        "KS-East, Manhattan/Topeka/Lawrence",
                        "KS-KC Metro",
                        "KS-West/W of Manhattan",
                        "KS-Wichita Metro",
                        "LA-New Orleans Metro",
                        "LA-North, N of Alexandria",
                        "LA-South, Alexandria & South",
                        "MO-Columbia/Jeff City Area",
                        "MO-KC Metro",
                        "MO-Springfield Metro",
                        "MO-St Joseph",
                        "MO-St Louis Metro",
                        "NE-Entire State",
                        "OK-East, E of I-35",
                        "OK-OKC Metro",
                        "OK-Tulsa Metro",
                        "OK-West, W of I-35",
                        "TX-Austin Metro",
                        "TX-DFW Metro",
                        "TX-Houston Metro",
                        "TX-North East, Waco/Longview",
                        "TX-San Antonio Metro",
                        "TX-South East, Lufkin/Bryan CS/Beaumont",
                        "TX-Valley, Victoria/Corpus/McAllen",
                        "TX-West, Abilene/Lubbock",
                        "Other",
                      ]
                        .concat(selectedContact.GMB_Region__c || [])
                        .filter((item, index, arr) => arr.indexOf(item) === index) // Ensure uniqueness
                        .map((region) => (
                          <option key={region} value={region}>
                            {region}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Phone</label>
                    <input
                      type="text"
                      value={selectedContact.Phone}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, Phone: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Mobile</label>
                    <input
                      type="text"
                      value={selectedContact.MobilePhone}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, MobilePhone: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Fax</label>
                    <input
                      type="text"
                      value={selectedContact.Fax}
                      className="w-full p-2 border rounded-md"
                      onChange={(e) =>
                        setSelectedContact((prev) => ({ ...prev, Fax: e.target.value }))
                      }
                      disabled={isLoading}
                      autoComplete="new-password"
                      autoCorrect="off"
                      spellCheck="false"
                      data-form-type="other"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mt-4">
                  <div>
                    <h3 className="block text-sm text-gray-600 mb-1">Mailing Address</h3>
                    <div className="mb-2">
                      <input
                        type="text"
                        value={selectedContact.MailingAddress?.street || ''}
                        placeholder="Street"
                        className="w-full p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            MailingAddress: { ...prev.MailingAddress, street: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-2">
                      <input
                        type="text"
                        value={selectedContact.MailingAddress?.city || ''}
                        placeholder="City"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            MailingAddress: { ...prev.MailingAddress, city: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <input
                        type="text"
                        value={selectedContact.MailingAddress?.state || ''}
                        placeholder="State"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            MailingAddress: { ...prev.MailingAddress, state: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <input
                        type="text"
                        value={selectedContact.MailingAddress?.postalCode || ''}
                        placeholder="Zip/Postal Code"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            MailingAddress: { ...prev.MailingAddress, postalCode: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <input
                        type="text"
                        value={selectedContact.MailingAddress?.country || ''}
                        placeholder="Country"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            MailingAddress: { ...prev.MailingAddress, country: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                    </div>
                  </div>

                  <div>
                    <h3 className="block text-sm text-gray-600 mb-1">Alternate Address</h3>
                    <div className="mb-2">
                      <input
                        type="text"
                        value={selectedContact.OtherAddress?.street || ''}
                        placeholder="Street"
                        className="w-full p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            OtherAddress: { ...prev.OtherAddress, street: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-2">
                      <input
                        type="text"
                        value={selectedContact.OtherAddress?.city || ''}
                        placeholder="City"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            OtherAddress: { ...prev.OtherAddress, city: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <input
                        type="text"
                        value={selectedContact.OtherAddress?.state || ''}
                        placeholder="State"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            OtherAddress: { ...prev.OtherAddress, state: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <input
                        type="text"
                        value={selectedContact.OtherAddress?.postalCode || ''}
                        placeholder="Zip/Postal Code"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            OtherAddress: { ...prev.OtherAddress, postalCode: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                      <input
                        type="text"
                        value={selectedContact.OtherAddress?.country || ''}
                        placeholder="Country"
                        className="p-2 border rounded-md"
                        onChange={(e) =>
                          setSelectedContact((prev) => ({
                            ...prev,
                            OtherAddress: { ...prev.OtherAddress, country: e.target.value },
                          }))
                        }
                        disabled={isLoading}
                        autoComplete="new-password"
                        autoCorrect="off"
                        spellCheck="false"
                        data-form-type="other"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-span-3">
                  <label className="block text-sm text-gray-600 mb-1">Account Billing State (Short Code)</label>
                  <select
                    className="w-full p-2 border rounded-md"
                    defaultValue={selectedContact.Account_Billing_State || ""}
                    style={{ color: selectedContact.Account_Billing_State ? "black" : "gray" }}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedContact((prev) => ({ ...prev, Account_Billing_State: value }));
                      e.target.style.color = value === "" ? "gray" : "black";
                    }}
                    disabled={isLoading}
                    autoComplete="new-password"
                    autoCorrect="off"
                    spellCheck="false"
                    data-form-type="other"
                  >
                    <option value="" disabled>Select the state</option>
                    {states.map((state) => (
                      <option key={state} value={state}>{state}</option>
                    ))}
                  </select>
                </div>

                <div className="flex justify-center mt-6">
                {noEmailFound ? (
                  <button
                    type="button"
                    className="w-1/4 bg-red-700 text-white py-2 px-4 rounded-lg hover:bg-red-800"
                    onClick={handleCreateContact}
                    disabled={isLoading}
                  >
                    Create Contact
                  </button>
                ) : (
                  <button
                    type="button"
                    className="w-1/4 bg-red-700 text-white py-2 px-4 rounded-lg hover:bg-red-800"
                    onClick={handleUpdateContact}
                    disabled={isLoading}
                  >
                    Update Contact
                  </button>
                )}
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}